/**
 * @param {string} paramName
 * @param {string} paramValue
 * */
export function addParamToURL(paramName, paramValue) {
    const url = new URL(window.location.href);
    url.searchParams.set(paramName, paramValue);
    window.history.pushState(null, null, url);
}

/** @param {string} paramName */
export function removeParamFromURL(paramName) {
    const url = new URL(window.location.href);
    url.searchParams.delete(paramName);
    window.history.replaceState(null, null, url);
}


/**
 * @returns {string[]|null}
 */
export function getQueryParamFromUrl(paramName) {
    const queryParams = new URLSearchParams(window.location.search);
    const param = queryParams.get(paramName);
    if (param != null && param.trim())
        return param.split(',');
    return [];
}

/**
 * @param {string[]} ids
 */
export function addStructureIdsToUrl(ids){
    removeParamFromURL('context');
    if (!ids || !ids.length) {
        removeParamFromURL('structureIds')
        return
    }
    addParamToURL('structureIds', ids.join(","))
}

/** @returns {string[]|null} */
export function getStructureIdsFromUrl(){
    return getQueryParamFromUrl('structureIds')
}